import { proxy } from "valtio";

const userAuthFromLocalStorage = () => {
  const isAuth = localStorage.getItem("data-login");

  return !!(isAuth && JSON.parse(isAuth) === true);
};

const state = proxy({
  LOADING: true,
  token: userAuthFromLocalStorage(),
});

export default state;
